import script from "./AboutBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutBlock.vue?vue&type=script&setup=true&lang=js"

import "./AboutBlock.vue?vue&type=style&index=0&id=aadc8890&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aadc8890"]])

export default __exports__